<template lang="pug">
.GridOverlay
  .bar
  .bar
  .bar
  .bar
  .bar
  .bar
  .bar
  .bar
</template>

<script>
export default {
  name: 'GridOverlay',
  props: ['opacity'],
  mounted() {
    this.$el.style.opacity = this.opacity
  }
}
</script>

<style lang="scss">
$color: red;

.GridOverlay {
  color: $color;
  position: fixed;
  height: 100vh;
  z-index: 9999;
  pointer-events: none;

  .bar {
    border: 1px solid $color;
    background-color: rgba($color, 0.3);
    height: 100%;
  }

  @for $i from 0 to $cols-n {
    .bar:nth-last-of-type(#{$i + 1}) {
      @include grid(#{$i}, 1);
    }
  }
}
</style>
